import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import ItemsEditor from './PricingItemsEditor';

const CategoryDialog = ({ open, onOpenChange, draft, setDraft, onSave, saving }) => {
  const isEdit = Boolean(draft.id);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 text-white max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{isEdit ? 'Edit pricing category' : 'New pricing category'}</DialogTitle>
          <DialogDescription className="text-gray-400">
            Manage the category name, description and individual line items shown on the public pricing section.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-gray-300">Category name</Label>
            <Input
              data-testid="cat-name-input"
              value={draft.category}
              onChange={(e) => setDraft({ ...draft, category: e.target.value })}
              placeholder="e.g. Cleaning Services"
              className="bg-slate-800 border-slate-700 text-white"
            />
          </div>
          <div>
            <Label className="text-gray-300">Description (optional)</Label>
            <Textarea
              data-testid="cat-description-input"
              value={draft.description}
              onChange={(e) => setDraft({ ...draft, description: e.target.value })}
              rows={3}
              className="bg-slate-800 border-slate-700 text-white"
            />
          </div>
          <div>
            <Label className="text-gray-300">Line items</Label>
            <p className="text-xs text-gray-500 mb-2">Service name, price, and optional Basic/Advanced tag for styling.</p>
            <ItemsEditor items={draft.items} onChange={(items) => setDraft({ ...draft, items })} />
          </div>
          <div className="flex items-center gap-3">
            <Switch
              data-testid="cat-visible-switch"
              checked={draft.visible}
              onCheckedChange={(v) => setDraft({ ...draft, visible: v })}
            />
            <Label className="text-gray-300">
              {draft.visible ? 'Visible on public pricing' : 'Hidden'}
            </Label>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700 text-white hover:bg-slate-800">
            Cancel
          </Button>
          <Button
            data-testid="cat-save-button"
            onClick={onSave}
            disabled={saving || !draft.category.trim()}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {saving ? 'Saving…' : (isEdit ? 'Save changes' : 'Create category')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CategoryDialog;
